// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"418a3d6c","108":"c3b32001","209":"82dbb453","256":"0ee82f41","326":"82dbb453","328":"adb0709c","332":"41f2b55c","380":"921e8c4d","500":"f23cd3ac","668":"f64947a5","672":"3f984604","816":"4b873644","828":"adb0709c","904":"6f016564"}[chunkId] + ".chunk.css";
};